import { style } from "@vanilla-extract/css";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { rem } from "@huub-web/utils";
import { recipe } from "@vanilla-extract/recipes";

export const containerStyle = recipe({
  base: {},
  variants: {
    hideNeededSituation: {
      true: {
        maxWidth: rem(680),
        margin: "0 auto",
      },
    },
  },
});

export const cardInnerStyle = style({
  borderRadius: theme.borderRadiuses.s,
});

export const cardContentStyle = style({
  borderRadius: theme.borderRadiuses.s,
});

export const firstCardStyle = style({
  ...responsiveContainer({
    s: {
      paddingRight: theme.spacings.m,
    },
  }),
});

export const itemContentStyle = style({
  // gridTemplateColumns: "repeat(1, 1fr)",
  // gap: theme.spacings.m,
  // overflow: "hidden",
  // ...responsiveCard({
  //   340: {
  //     gridTemplateColumns: "repeat(2, 1fr)",
  //     gap: theme.spacings.xs,
  //   },
  // }),
});

export const singleItemStyle = style({
  width: "100%",
  margin: "0 auto",
});
